import React, { useEffect, useState } from "react";
import { baseUrl } from "../../../services/config";
import "./styles.css";
import HeadOfficeDashboard from "../../../app/modules/HeadOfficeDashboard/HeadOfficeDashboard";
import SuperAdminDashboard from "../../../components/SuperAdminDashboard/SuperAdminDashboard";
import CampusDashboard from "../../../components/CampusDashboard/CampusDashboard";

export function Demo1Dashboard() {
  const authtoken = localStorage.getItem("userToken");
  const [campuses, setcampuses] = useState([]);
  const [headoffices, setheadoffices] = useState([]);
  const [students, setstudents] = useState([]);

  useEffect(() => {
    getAllStudents();
    GetAllCampuses();
    GetAllheadoffice();
  }, []);

  const getAllStudents = async () => {
    await fetch(`${baseUrl}/student`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setstudents(data.payload);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const GetAllheadoffice = async () => {
    await fetch(`${baseUrl}/headoffice`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((headoffices) => {
        setheadoffices(headoffices.payload);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const GetAllCampuses = async () => {
    await fetch(`${baseUrl}/campus`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((campuses) => {
        setcampuses(campuses.payload);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  let user;
  if (localStorage.getItem("userDetails")) {
    user = JSON.parse(localStorage.getItem("userDetails"));
  }

  const role = user?.role?.[0] || "";
  const studentCount = Array.isArray(students) ? students.length : 0;
  const campusCount = Array.isArray(campuses) ? campuses.length : 0;
  const headOfficeCount = Array.isArray(headoffices) ? headoffices.length : 0;

  return (
    <div className="dashboard-shell">
      <div className="dashboard-hero">
        <div>
          <span className="dashboard-eyebrow">{role || "Dashboard"}</span>
          <h3>Welcome back, {user?.name || "User"}</h3>
          <p>
            {role} |{" "}
            {new Date().toLocaleDateString("en-PK", {
              weekday: "long",
              year: "numeric",
              month: "long",
              day: "numeric",
            })}
          </p>
        </div>
        <div className="dashboard-year-card">
          <div>{new Date().getFullYear()}</div>
          <span>ACADEMIC YEAR</span>
        </div>
      </div>

      <div className="dashboard-content">
        {role == "Super Admin" ? (
          <SuperAdminDashboard
            campusCount={campusCount}
            headOfficeCount={headOfficeCount}
            studentCount={studentCount}
          />
        ) : null}

        {role == "Campus" ? <CampusDashboard studentCount={studentCount} /> : null}

        {role == "Head Office" ? <HeadOfficeDashboard /> : null}
      </div>
    </div>
  );
}
